import { render, staticRenderFns } from "./ConfirmAction.vue?vue&type=template&id=b8756934&scoped=true&lang=pug&"
import script from "./ConfirmAction.vue?vue&type=script&lang=ts&"
export * from "./ConfirmAction.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmAction.vue?vue&type=style&index=0&id=b8756934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8756934",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCol,VDialog})
